'use client';

import { CartSlideoutComponent } from './CartSlideout';
import { CartSlideoutAccessoryList } from './CartSlideoutAccessoryList';
import { useCart } from '@peerless/ui-shared';

export const CartSlideoutContainer = () => {
  const { cartData } = useCart();

  return (
    <CartSlideoutComponent>
      {cartData?.accessories && cartData.accessories.length > 0 && (
        <CartSlideoutAccessoryList data={cartData?.accessories} />
      )}
    </CartSlideoutComponent>
  );
};
